import { render, staticRenderFns } from "./WalletTransactionMember.vue?vue&type=template&id=18040fe8&"
import script from "./WalletTransactionMember.vue?vue&type=script&lang=ts&"
export * from "./WalletTransactionMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports